import axios from 'axios'
import { toast } from 'react-toastify'
import { LocalStorage } from '../helpers'
import { TOKEN_KEY } from '../constants'
import { resetIdentity } from '../analytics-identity'

let instance

export const setToken = (token) => {
	LocalStorage.set(TOKEN_KEY, token)
}
  
export const getToken = () => {
	return LocalStorage.get(TOKEN_KEY)
}

export const removeToken = () => {
	LocalStorage.remove(TOKEN_KEY)
}

export const initClient = () => {

  instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  instance.interceptors.request.use(
    (config) => {
      if (getToken()) {
        config.headers.Authorization = `Bearer ${getToken()}`
      }

      return config
    }
  )
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const reqUrl = error.config?.url || '';

      if (status === 401) {
          removeToken();
          resetIdentity();
          window.location.href = '/';
          return Promise.reject(error);
      }

      if (status === 403 && reqUrl.includes('/users/me')) {
          removeToken();
          resetIdentity();
          window.location.href = '/';
          return Promise.reject(error);
      }

      // Демо-режим запрещает запись на бэкенде, и без этого тоста форма просто
      // ничего не делает: код у каждой формы свой, а точка отказа одна
      if (status === 403 && error.response?.data?.code === 'demo_read_only') {
          toast.warn(error.response.data.detail);
          return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  )
  return instance
}

export default (() => {
  if (typeof instance === 'undefined') {
    return initClient()
  }

  return instance
})()
